import { cn } from '@/lib/utils';

interface ViewToggleProps {
  isMapView: boolean;
  onToggle: (isMapView: boolean) => void;
}

export function ViewToggle({ isMapView, onToggle }: ViewToggleProps) {
  const handleMapToggle = () => {
    const newMapView = !isMapView;
    onToggle(newMapView);
    console.log('지도로 보기 clicked');
    
    // 지도로 보기 클릭 시 자동 스크롤
    if (newMapView) {
      setTimeout(() => {
        // 탭 영역까지 스크롤
        const tabElement = document.querySelector('[data-map-tab]');
        if (tabElement) {
          tabElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  return (
    <nav style={{ marginBottom: '0px', marginTop: '16px' }} data-map-tab>
      <div className="flex gap-1">
        <button
          onClick={() => onToggle(false)}
          className={cn(
            "flex-1 text-center transition-all duration-200 border border-[#F5F5F5]",
            !isMapView
              ? "bg-[#F5F5F5] text-[#222222]"
              : "bg-[#FFFFFF] text-[#979797]"
          )}
          style={{
            height: '44px',
            fontSize: '16px',
            fontWeight: '600',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: !isMapView ? '2px 0 2px rgba(0, 0, 0, 0.05)' : 'none'
          }}
        >
          리스트로 보기
        </button>
        <button
          onClick={handleMapToggle}
          className={cn(
            "flex-1 text-center transition-all duration-200 border border-[#F5F5F5]",
            isMapView
              ? "bg-[#F5F5F5] text-[#222222]"
              : "bg-[#FFFFFF] text-[#979797]"
          )}
          style={{
            height: '44px',
            fontSize: '16px',
            fontWeight: '600',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          지도로 보기
        </button>
      </div>
    </nav>
  );
}